export const setObjValuesToFalse = (initialState, selectedKey) => {
  for (let key in initialState) {
    if (key !== selectedKey) initialState[key] = false;
  }
  return initialState;
};
